// Internal Imports
import { get, post, put, deleteApi } from "../../api/index";
import { API_ENDPOINTS } from "../../constants";

// Destructuring
const { APIS } = API_ENDPOINTS;

export const getAssetFolderTreeService = () =>
  new Promise((resolve, reject) => {
    get(`${APIS.ASSET_FOLDER}/tree`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.debug(
          `assetServices => getAssetFolderTreeService => Error : ${error}`,
        );
        reject(error);
      });
  });

export const getAssetStatusListService = () =>
  new Promise((resolve, reject) => {
    get(`${APIS.ASSET_STATUS_LIST}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.debug(
          `assetServices => getAssetStatusListService => Error : ${error}`,
        );
        reject(error);
      });
  });

export const updateAssetStatusListService = payload =>
  new Promise((resolve, reject) => {
    put(`${APIS.ASSET_STATUS_LIST}`, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.debug(
          `assetServices => updateAssetStatusListService => Error : ${error}`,
        );
        reject(error);
      });
  });

export const deleteAssetStatusService = deleteId =>
  new Promise((resolve, reject) => {
    deleteApi(`${APIS.ASSET_STATUS_LIST}/${deleteId}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.debug(
          `assetServices => deleteAssetStatusService => Error : ${error}`,
        );
        reject(error);
      });
  });

export const getAssetTagsListService = () =>
  new Promise((resolve, reject) => {
    get(`${APIS.ASSET_TAGS_LIST}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.debug(
          `assetServices => getAssetTagsListService => Error : ${error}`,
        );
        reject(error);
      });
  });

export const updateAssetTagsListService = payload =>
  new Promise((resolve, reject) => {
    put(`${APIS.ASSET_TAGS_LIST}`, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.debug(
          `assetServices => updateAssetTagsListService => Error : ${error}`,
        );
        reject(error);
      });
  });

export const deleteAssetTagService = deleteId =>
  new Promise((resolve, reject) => {
    deleteApi(`${APIS.ASSET_TAGS_LIST}/${deleteId}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.debug(
          `assetServices => deleteAssetTagService => Error : ${error}`,
        );
        reject(error);
      });
  });

export const getAssetFolderContentService = (queryParams, assetDataToFetch) =>
  new Promise((resolve, reject) => {
    const api =
      assetDataToFetch === "all"
        ? `${APIS.ASSET_FOLDER}/?${queryParams}`
        : APIS.ASSET_MY_DOCUMENTS;
    get(`${api}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.debug(
          `assetServices => getAssetFolderContentService => Error : ${error}`,
        );
        reject(error);
      });
  });

export const createAssetFolderService = payload =>
  new Promise((resolve, reject) => {
    post(`${APIS.ASSET_FOLDER}/`, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.debug(
          `assetServices => getAssetFolderTreeService => Error : ${error}`,
        );
        reject(error);
      });
  });

export const deleteAssetItemsService = payload =>
  new Promise((resolve, reject) => {
    post(`${APIS.ASSET_FOLDER}/delete`, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.debug(
          `assetServices => deleteAssetItemsService => Error : ${error}`,
        );
        reject(error);
      });
  });

export const moveToAssetItemsService = payload =>
  new Promise((resolve, reject) => {
    post(`${APIS.ASSET_FOLDER}/move`, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.debug(
          `assetServices => moveToAssetItemsService => Error : ${error}`,
        );
        reject(error);
      });
  });

export const renameAssetItemService = payload =>
  new Promise((resolve, reject) => {
    put(`${APIS.ASSET_FOLDER}/items/${payload.id}`, payload.data)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.debug(
          `assetServices => renameAssetItemService => Error : ${error}`,
        );
        reject(error);
      });
  });

export const fetchAssetCollaboratorListService = assetItemId =>
  new Promise((resolve, reject) => {
    get(`${APIS.ASSET_SHARING}/${assetItemId}`)
      .then(response => {
        resolve(response.acl);
      })
      .catch(error => {
        console.debug(
          `assetServices => fetchAssetCollaboratorListService => Error : ${error}`,
        );
        reject(error);
      });
  });

// 'assetCollaboratorAccessService', this service will be used for "ADD", "CHANGE"
// and "DELETE" collaborators
export const assetCollaboratorAccessService = (payload, type) =>
  new Promise((resolve, reject) => {
    let url;
    let tempPayload;
    if (type === "ADD") {
      url = `${APIS.ASSET_BATCH_SHARING}/${payload.assetItemId}`;
      tempPayload = payload.data;
    } else if (type === "CHANGE" || type === "DELETE") {
      url = `${APIS.ASSET_SHARING}/`;
      tempPayload = payload;
    }

    if (url) {
      post(url, tempPayload)
        .then(response => {
          resolve(response.access);
        })
        .catch(error => {
          console.debug(
            `assetServices => assetAddCollaboratorsService => Error : ${error}`,
          );
          reject(error);
        });
    }
  });

export const updateAssestStatusService = (docId, statusId) =>
  new Promise((resolve, reject) => {
    post(`${APIS.DOC_STATUS}/${docId}/${statusId}`)
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  });

export const updateAssestTagService = (docId, tagId) =>
  new Promise((resolve, reject) => {
    post(`${APIS.DOC_TAG}/${docId}/${tagId}`)
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  });

export const getAssetSearchSuggestionService = searchTerm =>
  new Promise((resolve, reject) => {
    get(`${APIS.ASSET_SEARCH_SUGGESTION}?term=${searchTerm}`)
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  });

export const getAssetSearchResults = (
  keyword,
  pageNum = "0",
  sortByDocNum = false,
  sortByStatus = false,
  sortByTags = false,
  sortDesc = false,
) =>
  new Promise((resolve, reject) => {
    get(
      `${
        APIS.ASSET_FOLDER_SEARCH
      }?search=${keyword}&page_num=${pageNum}&sort_by_doc_num=${sortByDocNum}&sort_by_status=${sortByStatus}&sort_by_tags=${sortByTags}&sort_desc=${sortDesc}`,
    )
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  });



// WEBPACK FOOTER //
// ./src/actions/AssetActions/assetServices.js